import createTsdApi from "../../../client-api/createTsdApi";
import {
  IdCardTemplateRegion,
  IdCardTemplateRegionCreateParams,
  IdCardTemplateRegionQueryParams,
  IdCardTemplateRegionUpdateParams,
} from "../../../entities/IdCardTemplateRegion/idCardTemplateRegion";
import { TsdSearchParam } from "../fetch";

const idCardTemplateRegionApi = createTsdApi<
  IdCardTemplateRegion,
  IdCardTemplateRegionQueryParams,
  IdCardTemplateRegionCreateParams,
  IdCardTemplateRegionUpdateParams
>("id-card-template-regions", (params) => {
  const search: TsdSearchParam<IdCardTemplateRegionQueryParams>[] = [];

  ({
    ids: (() => {
      if (typeof params.ids !== "undefined") {
        params.ids.forEach((id) =>
          search.push({ key: "ids", value: String(id) })
        );
      }
    })(),
    limit: (() => {
      if (typeof params.limit !== "undefined") {
        search.push({
          key: "limit",
          value: String(params.limit),
        });
      }
    })(),
    offset: (() => {
      if (typeof params.offset !== "undefined") {
        search.push({
          key: "offset",
          value: String(params.offset),
        });
      }
    })(),
    idCardTemplateIds: (() => {
      if (typeof params.idCardTemplateIds !== "undefined") {
        params.idCardTemplateIds.forEach((id) =>
          search.push({ key: "idCardTemplateIds", value: String(id) })
        );
      }
    })(),
    isDeleted: (() => {
      if (typeof params.isDeleted !== "undefined") {
        search.push({ key: "isDeleted", value: params.isDeleted ? "1" : "0" });
      }
    })(),
  }) satisfies {
    [key in keyof Required<IdCardTemplateRegionQueryParams>]: void | undefined;
  };

  return search;
});

export default {
  get: idCardTemplateRegionApi.get,
  getOne: idCardTemplateRegionApi.getOne,
  create: idCardTemplateRegionApi.create,
};
